import { useNavigate } from 'react-router';
import { clsx } from 'clsx';

import type { ReactNode } from 'react';

import styles from './ProgrammeCard.module.css';

export interface ProgrammeCardProps {
  /** The URL to navigate to when the card is clicked. */
  href: string;
  /** The header contents. */
  header?: ReactNode;
  /** The programme details. */
  details?: ReactNode;
  isNew?: boolean;
}

/** Represents a component to render a card for a programme. */
export const ProgrammeCard = ({ href, header, details, isNew }: ProgrammeCardProps) => {
  const navigate = useNavigate();

  return (
    <a
      className={clsx(styles['programme-card'], isNew && styles['programme-card--new'])}
      href={href}
      onClick={(event) => {
        // lets browser handle new tab
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
          return;
        }
        event.preventDefault();
        // lets react-router handle SPA-style navigation
        navigate(href);
      }}
    >
      {header}
      {details && <hr className={styles['programme-card__divider']} />}
      {details}
    </a>
  );
};
